/**
 * O que o arquivar até ter estoque fez, com os números (F247) — inclusive os
 * poupados por terem saldo em alguma filial, e o "nada mudou".
 */
export const shelfMessage = (
  action: 'shelve' | 'unshelve',
  changed: number,
  kept: number
): string => {
  const plural = (n: number, one: string, many: string): string =>
    n === 1 ? `1 ${one}` : `${String(n)} ${many}`
  if (action === 'unshelve') {
    return changed === 0
      ? 'Nenhum produto mudou: nenhum estava arquivado até ter estoque.'
      : `${plural(changed, 'produto voltou', 'produtos voltaram')} a aparecer.`
  }
  const kepts =
    kept === 0
      ? ''
      : ` ${plural(kept, 'tem estoque em alguma filial e ficou', 'têm estoque em alguma filial e ficaram')}.`
  return changed === 0
    ? `Nenhum produto foi arquivado.${kepts}`
    : `${plural(changed, 'produto arquivado', 'produtos arquivados')} até ter estoque.${kepts}`
}
